export default function WorkMethod() {
  const methods = [
    {
      icon: 'ri-chat-3-line',
      title: 'Entrevista inicial',
      description: 'Para que exponga su caso y nos explique su situación real desde el punto de vista personal, económico y jurídico.'
    },
    {
      icon: 'ri-newspaper-line',
      title: 'Análisis Legal',
      description: 'Estudiamos su asunto de manera personalizada para verificar todas las posibles soluciones jurídicas que se adaptan a su caso.'
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Actuación Jurídica',
      description: 'Analizamos las posibles vías de actuación preventivas y/o correctivas, y defendemos sus intereses dentro y fuera de los juzgados.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2C3E50] text-center mb-12">
          Nuestro método de trabajo
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {methods.map((method, index) => (
            <div
              key={index}
              className="bg-[#34495E] rounded-lg p-8 text-center hover:shadow-xl transition-all duration-300"
            >
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 bg-[#A77047] rounded-full flex items-center justify-center">
                  <i className={`${method.icon} text-3xl text-white`}></i>
                </div>
              </div>
              <h3 className="font-heading text-xl font-bold text-white mb-4">
                {method.title}
              </h3>
              <p className="text-white/80 text-sm leading-relaxed">
                {method.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}